<template>
  <fieldset>
    <input-with-validation
        type="email"
        label="Email Address"
        :regex="'^.{1,255}[@].{1,255}[.].{1,255}$'"
        :required="true"
        :loading="loading"
        failure-msg="Please enter a valid email address"
        name="email"
        :value="value"
        ref="emailInput"
        v-on:input="input">
    </input-with-validation>

    <small v-if="suggestedValue" class="input__suggest-value">
        Did you mean <span v-on:click="useSuggestedValue">{{ suggestedValue }}</span>?
    </small>
  </fieldset>
</template>

<script>
  import MailCheck from 'mailcheck'
  import inputWithValidation from './inputWithValidation'

  export default {
    name: 'emailInput',
    props: [
      'value',
      'loading'
    ],
    components: {
      inputWithValidation
    },
    data () {
      return {
        suggestedValue: null
      }
    },
    methods: {
      isValid () {
        return this.$refs.emailInput.isValid()
      },

      highlightError () {
        return this.$refs.emailInput.highlightError()
      },

      input (email) {
        this.$emit('input', email)
        this.checkEmailAddress(email)
      },

      checkEmailAddress (email) {
        this.suggestedValue = null

        MailCheck.run({
          email: email,
          suggested: (suggestion) => {
            if (suggestion.full !== email) {
              this.suggestedValue = suggestion.full
            }
          }
        })
      },

      useSuggestedValue () {
        this.$emit('input', this.suggestedValue)
        this.suggestedValue = ''
      }
    }

  }
</script>



// WEBPACK FOOTER //
// emailInput.vue?ea2441e6